module.exports = __webpack_public_path__ + "./docs/img/icon-linkedin-gray.c67ba3f47ef05a3ce3e2bd74e1b8ac6d.svg";